import { formatCpfNumber } from "../../../../../app/utils/cpfFormater";
import { CustomerInfo } from "../../../../../app/entities/CustomerInfo";
import { formatPhoneNumber } from "../../../../../app/utils/formatPhoneNumber";
import { Whatsapp } from "iconsax-react";
import { formatDate } from "@/app/utils/formatDate";
import { useToast } from "@/view/components/ui/use-toast";

type CustomerPersonalInfoProps = {
  data: CustomerInfo;
};

export const CustomerPersonalInfo = ({ data }: CustomerPersonalInfoProps) => {
  const { toast } = useToast()

  const items = [
    {
      label: "Data de nascimento:",
      value: data.birthDate ? formatDate(data.birthDate) : "Não informado",
    },
    {
      label: "CPF:",
      value: formatCpfNumber(data.cpf),
      rawValue: data.cpf,
      copyable: true,
    },
    {
      label: "Email:",
      value: data.email,
      rawValue: data.email,
      copyable: true,
    },
    {
      label: "Telefone:",
      value: formatPhoneNumber(data.phone),
      icon: (
        <Whatsapp
          className="cursor-pointer text-green-500 hover:text-green-600"
          onClick={() => window.open(`https://wa.me/${data.phone}`)}
        />
      ),
    },
    // {
    //   label: 'Endereço',
    //   value: data.address
    //     ? `${data.address.street}, ${data.address.number} - ${data.address.complement ?? ''}
    //     ${data.address.neighborhood} | ${data.address.city} - ${data.address.state}`
    //     : '',
    // },
  ];


  const copy = async (s: string) => {
    try {
      await navigator.clipboard.writeText(s)
      toast({
        title: 'Copiado!',
      })
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }



  return (
    <div>
      <h2 className="my-5 font-semibold text-[#A68E38]">
        Informações pessoais
      </h2>
      <div className="space-y-2">
        {items.map(({ label, value, icon, copyable, rawValue }) => (
          <div className="flex items-center gap-2" key={`${label}-${value}`}>
            <p className="text-sm font-semibold text-black04">{label}</p>
            <p 
              className={`text-sm font-medium ${copyable ? 'cursor-pointer' : ''}`}
              onClick={copyable && rawValue ? () => copy(rawValue) : undefined}
            >
              {value}
            </p>
            {icon}
          </div>
        ))}
      </div>
    </div>
  );
};
